/* eslint-disable:  @typescript-eslint/camelcase */
const Content = {
    Current_month: "current month",
    Year: "Year",
    Please_select_a_year: "Please select a year",
};

export const InvalidateDate = "0001-01-01T00:00:00";

export default Content;
